/**
 * Algolia Animations - Simplified Responsive System
 * Part of Deuxpardeux Algolia custom implementation
 */

class SimplifiedAnimator {
  constructor() {
    this.setupResizeHandler();
    window.threePhaseAnimator = this;
  }

  setupResizeHandler() {
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        this.updateGridLayout();
      }, 150);
    });
  }

  isDesktopSize() {
    return window.matchMedia('(min-width: 1024px)').matches;
  }

  getCurrentColumns() {
    const isSidebarOpen = document.querySelector('.algolia-custom-layout')?.classList.contains('sidebar-open');
    const isTablet = window.matchMedia('(min-width: 1024px)').matches;
    const isDesktop = window.matchMedia('(min-width: 1280px)').matches;

    if (isDesktop) {
      return isSidebarOpen ? 3 : 4;
    } else if (isTablet) {
      return isSidebarOpen ? 2 : 3;
    }
    
    return 2;
  }

  updateGridLayout() {
    const hitsList = document.querySelector('.ais-Hits-list');
    if (!hitsList) return;

    const columns = this.getCurrentColumns();
    hitsList.style.gridTemplateColumns = `repeat(${columns}, 1fr)`;
    hitsList.dataset.gridColumns = columns;
  }

  animateSidebarToggle() {
    const layout = document.querySelector('.algolia-custom-layout');
    const searchSidebar = document.querySelector('.search-sidebar');
    if (!layout || !searchSidebar) return;

    const isOpening = !layout.classList.contains('sidebar-open');
    
    layout.classList.toggle('sidebar-open', isOpening);
    searchSidebar.inert = !isOpening;
    
    this.updateGridLayout();

    // Handle body scroll for mobile (non-desktop)
    if (!this.isDesktopSize()) {
      if (isOpening) {
        document.documentElement.style.setProperty('overflow', 'hidden');
      } else {
        document.documentElement.style.removeProperty('overflow');
      }
    }
  }

  toggleSidebarImmediate() {
    const layout = document.querySelector('.algolia-custom-layout');
    const searchSidebar = document.querySelector('.search-sidebar');
    if (!layout || !searchSidebar) return;
    
    layout.classList.add('no-transition');
    
    const isOpening = !layout.classList.contains('sidebar-open');
    layout.classList.toggle('sidebar-open', isOpening);
    searchSidebar.inert = !isOpening;
    this.updateGridLayout();

    // Force reflow to apply changes without transition
    layout.offsetHeight;
    layout.classList.remove('no-transition');
  }
}

// Initialize animator
window.threePhaseAnimator = new SimplifiedAnimator(); 